import { Check, Github, Loader2, X } from 'lucide-react';
import { useState } from 'react';

interface TicketActionsProps {
  ticketId: string;
  isApproving: boolean;
  isRejecting: boolean;
  onApprove: (id: string) => void;
  onReject: (id: string, reason?: string) => void;
}

export const TicketActions = ({
  ticketId,
  isApproving,
  isRejecting,
  onApprove,
  onReject,
}: TicketActionsProps) => {
  const [showRejectInput, setShowRejectInput] = useState(false);
  const [rejectReason, setRejectReason] = useState('');
  const isPending = isApproving || isRejecting;

  return (
    <div className="flex flex-col items-end gap-2">
      <div className="flex gap-2">
        <button
          type="button"
          disabled={isPending}
          onClick={() => onApprove(ticketId)}
          className="flex items-center gap-2 rounded-lg bg-green-600 px-4 py-2 text-sm font-medium text-white transition hover:bg-green-500 disabled:bg-slate-300"
        >
          {isApproving ? (
            <Loader2 className="h-4 w-4 animate-spin" />
          ) : (
            <Github className="h-4 w-4" />
          )}
          Godkänn → GitHub-issue
        </button>
        <button
          type="button"
          disabled={isPending}
          onClick={() => setShowRejectInput((open) => !open)}
          className="flex items-center gap-2 rounded-lg border border-slate-300 px-4 py-2 text-sm font-medium text-slate-700 transition hover:bg-slate-100 disabled:opacity-50"
        >
          <X className="h-4 w-4" /> Avvisa
        </button>
      </div>

      {showRejectInput && (
        <div className="flex items-center gap-2">
          <input
            type="text"
            value={rejectReason}
            onChange={(event) => setRejectReason(event.target.value)}
            placeholder="Anledning (valfritt)"
            className="rounded-lg border border-slate-300 px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400"
          />
          <button
            type="button"
            disabled={isRejecting}
            onClick={() => onReject(ticketId, rejectReason.trim() || undefined)}
            className="flex items-center gap-1.5 rounded-lg bg-slate-700 px-3 py-1.5 text-sm font-medium text-white transition hover:bg-slate-600 disabled:bg-slate-300"
          >
            <Check className="h-4 w-4" /> Bekräfta
          </button>
        </div>
      )}
    </div>
  );
};
